var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudInfrastructure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 15.8333H7.50005C6.41827 15.833 5.35788 15.532 4.43737 14.9637C3.51685 14.3955 2.77249 13.5824 2.28744 12.6155C1.8024 11.6486 1.5958 10.5658 1.69071 9.48818C1.78563 8.41057 2.17833 7.38058 2.82492 6.51331C3.47152 5.64604 4.34655 4.97565 5.35222 4.57706C6.35789 4.17847 7.45459 4.06739 8.51976 4.25621C9.58493 4.44504 10.5766 4.92634 11.384 5.64633C12.1914 6.36632 12.7826 7.29664 13.0917 8.33333H14.5834C15.5779 8.33333 16.5318 8.72841 17.235 9.43167C17.9383 10.1349 18.3334 11.0888 18.3334 12.0833C18.3334 13.0779 17.9383 14.0317 17.235 14.735C16.5318 15.4382 15.5779 15.8333 14.5834 15.8333Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudInfrastructure);
export default __webpack_public_path__ + "static/media/Cloud Infrastructure.374db786d044f7e3b844440467d65934.svg";
export { ForwardRef as ReactComponent };